import React from 'react'

import Image from 'next/image'

import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { Maybe } from 'src/graphql/types'

import s from './CandidateCardHeader.module.scss'

export interface ICandidateCardHeaderProps {
  name: Maybe<string>
  role?: Maybe<string>
  avatarSrc?: Maybe<string>
}

export const CandidateCardHeader: React.FC<ICandidateCardHeaderProps> = ({
  name,
  role,
  avatarSrc,
}) => (
  <div className={s.CandidateCardHeader}>
    <div className={s.CandidateCardHeader__avatar}>
      {avatarSrc && (
        <Image
          src={avatarSrc}
          alt={name || ''}
          layout="fill"
          quality={100}
          unoptimized
        />
      )}
    </div>

    <div>
      {name && (
        <Typography
          variant={EnumTypographyVariants.H7}
          className={s.CandidateCardHeader__name}
          text={name}
        />
      )}

      {role && (
        <Typography
          variant={EnumTypographyVariants.H9}
          className={s.CandidateCardHeader__role}
          text={role}
        />
      )}
    </div>
  </div>
)
